import ResourceService from "./resource.service";

class CategoryService extends ResourceService {
  static get resource() {
    return "category";
  }
}

export default CategoryService;
